<template>
  <div>
    <ed-empresa :intCadastroGeralId="$route.params.intId" :intTipoCadastroGeralId="300" :key="$root.$session.versao"/>
  </div>
</template>

<script>
import EdEmpresa from "@/components/cadastro/geral/index";

export default {
  name: "pageCadastroEmpresa",
  props: {},
  components: {EdEmpresa },
  mounted() {
  },
  created() {},
  data() {
    return {
    };
  },
  methods: {
  
  },
};
</script>